import './AdvantagesList.styles.scss';

import PropTypes from 'prop-types';

import AdvantagesItem from './AdvantagesItem/AdvantagesItem';

const AdvantagesList = ({ arrayOfItems = [] }) => {
    return (
        <ul className="advantages__list grid justify-space">
            {arrayOfItems.map((item, index) => (
                <AdvantagesItem key={index} icon={item.icon} title={item.title} text={item.text} />
            ))}
        </ul>
    );
};

AdvantagesList.propTypes = {
    arrayOfItems: PropTypes.array.isRequired,
};

export default AdvantagesList;
